export default __webpack_public_path__ + "img/map-marker-coordinator_site-active.f008b5dc.png";